import { Injectable } from '@angular/core';
import { StatsDataDetails } from '../insurance/model/StatsDataDetails';
import { InsrAcqnDashboardDetails } from '../model/InsuranceAcquisitionDetails';
import * as _ from 'lodash-es';

@Injectable()
export class InsuranceService {

  constructor() { }

  complianceCalculationInsurance(acqInsuranceDetails: InsrAcqnDashboardDetails[], requireFloodINS: String): StatsDataDetails {
    // console.log("InsuranceService::complianceCalculationInsurance - acqInsuranceDetails = ", acqInsuranceDetails);
    
    let lenderStats = {
      noAcquisitions: 0,
      rateCompliance: 0,
      rateSubmission: 0
    } as StatsDataDetails;

    lenderStats.noAcquisitions = _.filter(acqInsuranceDetails, function (o) { return o.acquisitionStatus == 'Acquired' }).length;


      let acqInsuranceDetailsFilteredCompliance = _.filter(acqInsuranceDetails, function (o: InsrAcqnDashboardDetails) {
        return o.acquisitionStatus === 'Acquired' 
      });

      let acqInsuranceDetailsFilteredSubmissionRate = _.filter(acqInsuranceDetails, function (o: InsrAcqnDashboardDetails) {
        return o.acquisitionStatus === 'Acquired'
      });

      if (acqInsuranceDetailsFilteredCompliance.length > 0) {
        let compliantCount = 0;
        let nonCompliantCount = 0;
        let submissionCount_Y = 0;
        let submissionCount_N = 0;

        for (let i = 0; i < acqInsuranceDetailsFilteredSubmissionRate.length; i++) {
          const insuranceProps = [
            acqInsuranceDetailsFilteredSubmissionRate[i].insr,
            acqInsuranceDetailsFilteredSubmissionRate[i].propAccord25Typ,
            acqInsuranceDetailsFilteredSubmissionRate[i].propAccord28Typ,
            acqInsuranceDetailsFilteredSubmissionRate[i].propAmrcnLandTtlAsscTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propFldAnlysWkshTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propLiabPlcyTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propNfipTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propPrvtOrExcsFldInsrCvrgTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propInsrTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propSpclFldHzrdDtmnFormTyp,
            acqInsuranceDetailsFilteredSubmissionRate[i].propSchOfValTyp
          ];
          
          insuranceProps.forEach(prop => {
            if (prop === 'Y') submissionCount_Y++;
            else if (prop === 'N') submissionCount_N++;
          });
        }

        for (let i = 0; i < acqInsuranceDetailsFilteredCompliance.length; i++) {

          switch (acqInsuranceDetailsFilteredCompliance[i].complianceRate.toLowerCase()) {
            case "compliant":
              compliantCount++;
              break;
            case "non-compliant":
              nonCompliantCount++;
              break;
            default:
              break;
          }
        }

        if (submissionCount_Y > 0) {
          lenderStats.rateSubmission = (submissionCount_Y / (submissionCount_Y + submissionCount_N));
        } 
        if (compliantCount > 0) {
          lenderStats.rateCompliance = (compliantCount / (compliantCount + nonCompliantCount));
        } 
      }
    

    return lenderStats;
  }
}